module.exports = __webpack_public_path__ + "img/スズキ.21b596d5.png";